<div class="modal-header justify-content-between border-0 pb-0">
  <input type="text" class="form-control px-0 border-0 py-2" placeholder="Short Name" [(ngModel)]="title">
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body pt-0 px-3">
  <div class="mb-3">
    <label class="form-label">Response Message</label>
    <textarea class="form-control" rows="4" placeholder="Enter message content..." [(ngModel)]="response_message"></textarea>
  </div>
  <div class="mb-3 d-flex align-items-center border col-6 px-3">
    <label class="form-label me-2 mb-0">Shared With</label>
    <select class="form-select border-0 badge bg-light rounded-pill m-1 w-auto" [(ngModel)]="shared_with">
      <option *ngFor="let opt of sharedWithOptions" [value]="opt.value">{{ opt.label }}</option>
    </select>
  </div>
</div>
<div class="modal-footer border-0">
  <button type="button" class="btn primary-button gradient w-auto px-3" [ngClass]="{'disabled': isSaving || !title?.trim() || !response_message?.trim()}" (click)="save()">
    <i *ngIf="isSaving" class="fa-duotone fa-spinner-third fa-spin me-1"></i> Save
  </button>
</div>
